import React from 'react';

import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { useBreakpoint } from 'common/hooks';

import ContactFormatter from './Formaters/ContactFormatter';
import DateFormatter from './Formaters/DateFormatter';
import NameFormatter from './Formaters/NameFormatter';
import PanelsNumberFormatter from './Formaters/PanelsNumberFormatter';
import ProjectFormatter from './Formaters/ProjectFormatter';
import TypeFormatter from './Formaters/TypeFormatter';
import UserFormatter from './Formaters/UserFormatter';

const Columns = ({ handleClickView, hiddenColumns, orders }) => {
    const { t } = useTranslation();
    const breakpoint = useBreakpoint();

    const columnName = {
        display: 'flex',
        field: 'name',
        headerName: t('Name'),
        hide: hiddenColumns.includes('name'),
        minWidth: 250,
        order: orders?.name,
        renderCell: (params) => {
            const { row } = params;
            return (
                <NameFormatter handleClickView={handleClickView} row={row} />
            );
        },
    };

    let columns = [
        columnName,
        {
            display: 'flex',
            field: 'type',
            headerName: t('Type'),
            hide: hiddenColumns.includes('type'),
            minWidth: 120,
            order: orders?.type,
            renderCell: TypeFormatter,
        },
        {
            display: 'flex',
            field: 'project',
            headerName: t('Project'),
            hide: hiddenColumns.includes('project'),
            minWidth: 250,
            order: orders?.project,
            renderCell: ProjectFormatter,
        },
        {
            display: 'flex',
            field: 'contact',
            headerName: t('Contact'),
            hide: hiddenColumns.includes('contact'),
            minWidth: 250,
            order: orders?.contact,
            renderCell: ContactFormatter,
        },
        {
            display: 'flex',
            field: 'panels_counter',
            headerName: t('Panel', { count: 2 }),
            hide: hiddenColumns.includes('panels_counter'),
            minWidth: 120,
            order: orders?.panels_counter,
            renderCell: PanelsNumberFormatter,
        },
        {
            display: 'flex',
            field: 'created_by',
            headerName: t('User'),
            hide: hiddenColumns.includes('created_by'),
            minWidth: 180,
            order: orders?.created_by,
            renderCell: UserFormatter,
        },
        {
            display: 'flex',
            field: 'date',
            headerName: t('Date'),
            hide: hiddenColumns.includes('date'),
            minWidth: 120,
            order: orders?.date,
            renderCell: DateFormatter,
        },
    ];

    if (['xs', 'sm'].includes(breakpoint)) columns = [columnName];

    return orderBy(columns, ['order'], ['asc']);
};

Columns.propTypes = {
    handleClickView: PropTypes.func,
    hiddenColumns: PropTypes.array,
    orders: PropTypes.object,
    users: PropTypes.array,
};

export default Columns;
